export default "__VITE_ASSET__OVs4a7fP__"